<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"/>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"/>Товары</div>
            </div>
            <div class="panel-body pn">
                <per-pager v-bind:per-page="pagination.perPage"/>
                <table class="table table-striped table-hover datatables">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Наменование</th>
                            <th>Стоимость</th>
                            <th>Дата создания</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(good, index) in goods" v-bind:key="index">
                            <td>{{good.id}}</td>
                            <td>
                                <router-link :to="{name: 'catalog-good-edit', params: {id: good.id}}">
                                    {{good.name}}
                                </router-link>
                            </td>
                            <td>{{good.price}}</td>
                            <td>{{good.createdAt | dateFormatTimestamp('dd.mm.yyyy HH:MM:ss')}}</td>
                        </tr>
                    </tbody>
                </table>
                <paginator v-bind="pagination"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Good from "../../models/Good";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../data/Paginator'),
            PerPager: () => import('../data/PerPager'),
        },
        beforeMount() {
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.load();
        },
        data() {
            return {
                isLoading: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                goods: [],
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
        },
        methods: {
            async load() {
                this.isLoading = true;
                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();

                const {data, headers} = await Good.getList(page, perPage, '-id');
                this.setData(data, headers);
                this.isLoading = false;
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['catalog-list']) {
                    return this.$store.state.template.perPages['catalog-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'catalog-list', value: value})
            },
            setData(goods, headers) {
                this.goods = goods;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            }
        },
        metaInfo() {
            return {
                title: 'Товары - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
